export default "__VITE_ASSET__qmBxL4W6__"